function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.096 3.142a.5.5 0 010 .684l-3.52 3.69h9.963c.254 0 .461.217.461.484a.473.473 0 01-.461.484H3.576l3.52 3.69a.5.5 0 010 .684.447.447 0 01-.653 0L2.135 8.342a.5.5 0 010-.684l4.308-4.516a.447.447 0 01.653 0z",
  fill: "#2D2D2D"
});
function SvgFlechaizquierda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Flecha izquierda.svg";
export { SvgFlechaizquierda as ReactComponent };